import { Toaster as Sonner, toast } from 'sonner';
import { useColorMode } from './colorMode';

/**
 * Toasts: `toast.success('Ride ended')`, `toast.error(message)`, `toast.info(...)`,
 * `toast.promise(p, { loading, success, error })`. Mutations made with useResultMutation toast
 * on their own; call these only for things outside it.
 */
export { toast };

/**
 * Toast host: top-right under the header (bottom-right belongs to the assistant button), in the
 * console's typography and colour mode. Mounted once in UiProvider.
 */
export function Toaster() {
  const mode = useColorMode();
  return (
    <Sonner
      position="top-right"
      offset={{ top: 64, right: 16 }}
      theme={mode}
      closeButton
      richColors
      duration={4000}
      toastOptions={{ style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', borderRadius: '10px' } }}
    />
  );
}
